import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

@Component({
  selector: 'app-logged-menu',
  templateUrl: './logedinmenu.component.html'
})
export class loggedInMenuComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  @ViewChild('toggleBtn') private toggleBtn: ElementRef;

  constructor(public http: HttpTestService, public session: sessionServices) { }

  ngOnInit() {
	  this.getSession();
  }
  
  toggleNavBar() {
    this.toggleBtn.nativeElement.click();
  }
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}
  
  //logout function
	logout() {
		window.sessionStorage.setItem('sessionKey', "");
		self.location.replace('');
  }
  
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/loginmenu/logedinmenu.component.ts